'use client'

import { ButtonSecondary } from '@fukku/button/Secondary'
import { sendOnClickContactButton } from 'help/utils/analytics/analyticsEvents'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import style from './MoreContactOptionsButton.module.scss'

interface MoreContactOptionsButtonProps {
	readonly categoryName?: string
	readonly questionName?: string
	readonly showContact?: () => void
}

export function MoreContactOptionsButton({
	categoryName,
	questionName,
	showContact,
}: MoreContactOptionsButtonProps) {
	const { t } = useLabels()

	const handleOnClick = () => {
		sendOnClickContactButton({ categoryName, questionName })
		if (showContact) {
			showContact()
		}
	}

	return (
		<ButtonSecondary
			data-testid='help.footer.contactOptions.contact.button'
			className={style.button}
			onClick={handleOnClick}
		>
			{t('help.footer.moreHelp.contact.button')}
		</ButtonSecondary>
	)
}
